'use strict';

/**
  * target function should return true to increment run's counter
  */

module.exports = function(config) {
    var max = config.max;
    var runs = 0;

    return function() {
        var result;

        if (max > 0 && runs < max) {
            result = config.target.apply(config.context);
            if (result === true) runs++;
        }

        if (runs > 0 && runs === max) {
            if (typeof(config.onFinish) === 'function') {
                config.onFinish.call(config.context, result);
            }
        }
    };
};
